import React from 'react';
import { Activity, XCircle } from 'lucide-react';

interface ProgressBarProps {
  progress: number;
  message: string;
  className?: string;
  onCancel?: () => void;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ progress, message, className = '', onCancel }) => {
  return (
    <div className={`bg-white/90 backdrop-blur-lg rounded-2xl shadow-xl border border-slate-200/50 p-6 ${className}`}>
      <div className="flex items-center gap-4 mb-4">
        <Activity className="w-6 h-6 text-blue-600 animate-pulse" />
        <div className="flex-1">
          <p className="font-semibold text-slate-900">{message}</p>
          <p className="text-sm text-slate-600">{Math.round(progress)}% complete</p>
        </div>
        {onCancel && (
          <button
            onClick={onCancel}
            className="px-5 py-3 rounded-2xl font-bold transition-all duration-300 border-2 
                     shadow-lg hover:shadow-2xl transform hover:scale-105 active:scale-95
                     flex items-center justify-center gap-2
                     bg-gradient-to-br from-red-400 via-rose-400 to-red-500 
                     border-red-300 text-white shadow-red-400/60 hover:shadow-red-500/80
                     hover:from-red-500 hover:via-rose-500 hover:to-red-600"
            aria-label="Cancel analysis"
          >
            <XCircle className="w-5 h-5" />
            <span>Cancel</span>
          </button>
        )}
      </div>
      <div className="relative h-3 bg-slate-200 rounded-full overflow-hidden">
        <div
          className="absolute inset-y-0 left-0 bg-gradient-to-r from-cyan-500 via-blue-500 to-purple-600 rounded-full transition-all duration-300 shadow-lg shadow-blue-500/50"
          style={{ width: `${progress}%` }}
        >
          {/* Shimmer effect */}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shimmer" />
        </div>
      </div>
    </div>
  );
};
